import {
    GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE,
    GET_MIMAR_CONSTANTS_RESPONSE,
} from './types'

const INITIAL_STATE = {
   cancellationPolicyConstants: {},
   mimarConstansts: {},
}

const settings = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE:
            return {
                ...state,
                cancellationPolicyConstants: action.payload,
            }
        case GET_MIMAR_CONSTANTS_RESPONSE:
            return {
                ...state,
                mimarConstansts: action.payload,
            }
        default:
            return state;
    }
};

export default settings;